const formatBoolean = (value) => (value ? 'Oui' : 'Non');

export default formatBoolean;
